var mp = mp || {};

// Toogle Menu
//-----------------------------------------------------------------
mp.accordion = function() {
	var $element = $('.accordion');
    var $trigger = $('.accordion .accordion__heading');

    if (!$element.length) {
        return;
    }
    
    $trigger.on('click', function(e) {
        e.preventDefault();
        //$('.accordion__item').removeClass('open');
        $(this).parent().toggleClass('open');
    });
}


$(document).ready(function(){
    mp.accordion();
});